
import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import CustomPrototype from '@core/extensions/custom-prototype';
import { FaviconService } from '@core/services/favicon.service';
import { TenantService } from '@core/services/tenant.service';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from 'ngx-webstorage';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
  providers: [MessageService]
})
export class App {


  private router = inject(Router);
  private fav = inject(FaviconService);


  constructor(
    private translateService: TranslateService,
    private sessionStorage: SessionStorageService,
    public tenantService: TenantService,
  ) {


    // Registra as extensions do prototype
    /* ********************************************************************** */
    CustomPrototype.register();
    /* ********************************************************************** */


    // Atualiza o favicon de acordo com a rota
    /* ********************************************************************** */
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.fav.updateFavicon(event.urlAfterRedirects);
      }
    });
    /* ********************************************************************** */



    this.init();


  }

  init() {

    console.log("========== Iniciando Aplicação.");

    // create agentId
    /* ********************************************************************** */
    // verifica se já existe agentId. Se não existir cria, caso contrario não.
    if (!this.sessionStorage.retrieve('agentId')) {
      const agentId = uuid();
      this.sessionStorage.store('agentId', agentId);
    }
    /* ********************************************************************** */


    // translate service
    /* ********************************************************************** */
    ////translateService.setTranslation('en', translationsEN);
    // const browserLang = this.translateService.getBrowserLang()?.toLowerCase() || 'pt';
    // this.sessionStorage.store('agentLang', browserLang);
    // this.translateService.addLangs(['pt', 'en', 'es']);
    // this.translateService.setDefaultLang('en'); //info: se deichar direto pt, não muda para outras linguas. bug?
    // this.translateService.use(browserLang.match(/pt|en|es/) ? browserLang: 'pt'); // the lang to use, if the lang isn't available, it will use the current loader to get them
    /* ********************************************************************** */


    console.log("========== Aplicação Iniciada.");
  }

}
